<template>
  <v-card :disabled="loading" elevation="0" class="pa-2">
    <v-switch
      v-model="advertising.active"
      class="ma-0"
      dense
      hide-details
      inset
      :label="advertising.active ? 'فعال' : 'غیرفعال'"
    />

    <v-row v-if="advertising.active" class="mt-2" no-gutters>
      <v-col class="pa-2" cols="12">
        <div class="rowinfo">
          <v-text-field
            v-model="advertising.number"
            :rules="[
              (v) =>
                v > 0 || 'حداقل تعداد بنر تبلیغاتی نمیتواند از 1 کمتر باشد',
            ]"
            class="rounded-lg contentinfo"
            clearable
            dense
            label="حداکثر تعداد بنر تبلیغاتی"
            outlined
            type="number"
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-maxCount`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="حداکثر تعداد بنر تبلیغاتی"
          />
        </div>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <div class="rowinfo">
          <price-input
            v-model="advertising.pay.day"
            class="rounded-lg contentinfo"
            :error="
              rulesSetting('day', advertising.pay.day)
                ? [rulesSetting('day', advertising.pay.day)]
                : null
            "
            clearable
            dense
            label="هزینه روزانه"
            outlined
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-maxCount`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="هزینه روزانه"
          />
        </div>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <div class="rowinfo">
          <price-input
            v-model.number="advertising.pay.week"
            class="rounded-lg contentinfo"
            clearable
            dense
            label="هزینه هفتگی"
            outlined
            :error="
              rulesSetting('week', advertising.pay.week)
                ? [rulesSetting('week', advertising.pay.week)]
                : null
            "
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-number-perDayPrice-1w`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="هزینه هفتگی"
          />
        </div>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <div class="rowinfo">
          <price-input
            v-model.number="advertising.pay.month"
            class="rounded-lg"
            clearable
            dense
            label="هزینه ماهانه"
            outlined
            :error="
              rulesSetting('month', advertising.pay.month)
                ? [rulesSetting('month', advertising.pay.month)]
                : null
            "
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-number-perDayPrice-1m`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="هزینه ماهانه"
          />
        </div>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <div class="rowinfo">
          <price-input
            v-model.number="advertising.pay.treeMonth"
            :error="
              rulesSetting('treeMonth', advertising.pay.treeMonth)
                ? [rulesSetting('treeMonth', advertising.pay.treeMonth)]
                : null
            "
            class="rounded-lg"
            clearable
            dense
            label="هزینه سه‌ماهه"
            outlined
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-number-perDayPrice-3m`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="هزینه سه‌ماهه"
          />
        </div>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <div class="rowinfo">
          <price-input
            v-model.number="advertising.pay.sixMonth"
            :error="
              rulesSetting('sixMonth', advertising.pay.sixMonth)
                ? [rulesSetting('sixMonth', advertising.pay.sixMonth)]
                : null
            "
            class="rounded-lg"
            clearable
            dense
            label="هزینه شیش‌ماهه"
            outlined
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-number-perDayPrice-6m`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="هزینه شیش‌ماهه"
          />
        </div>
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <div class="rowinfo">
          <price-input
            v-model.number="advertising.pay.year"
            :error="
              rulesSetting('year', advertising.pay.year)
                ? [rulesSetting('year', advertising.pay.year)]
                : null
            "
            class="rounded-lg contentinfo"
            clearable
            dense
            label="هزینه یک‌ساله"
            outlined
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-number-perDayPrice-1y`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            label="هزینه یک‌ساله"
          />
        </div>
      </v-col>
    </v-row>

    <v-col cols="12" class="pa-2">
      <v-btn
        :loading="loading"
        @click="submitBanner"
        class="w-100"
        outlined
        color="green"
      >
        <v-icon>mdi-content-save-check</v-icon>
        ذخیره تنظیمات
      </v-btn>
    </v-col>
  </v-card>
</template>

<script>
import priceInput from "@/view/pages/uiBeautifier/priceInput";

export default {
  components: { priceInput },
  name: "advertisingBanner",
  props: {
    value: { Number, String },
  },
  data() {
    return {
      loading: false,
      advertising: {
        active: true,
        number: 1,
        pay: {
          day: 1000,
          week: 2000,
          month: 3000,
          treeMonth: 4000,
          sixMonth: 5000,
          year: 6000,
        },
      },
    };
  },

  mounted() {
    this.getBanner();
    //
  },

  methods: {
    rulesSetting(type, v) {
      switch (type) {
        case "day": {
          return v > 0 ? null : "مقدار پرداخت روزانه نمیتواند صفر باشد";
        }
        case "week": {
          return v > 0 && v > this.advertising.pay.day
            ? null
            : "مقدار پرداخت هفتگی نمیتواند خالی یا کمتر از مبالغ قبلی  باشد";
        }
        case "month": {
          return v > 0 &&
            v > this.advertising.pay.day &&
            this.advertising.pay.week
            ? null
            : "مقدار پرداخت ماهانه نمیتواند خالی یا کمتر از مبالغ قبلی کمتر  باشد";
        }

        case "treeMonth": {
          return v > 0 &&
            v > this.advertising.pay.day &&
            v > this.advertising.pay.month &&
            this.advertising.pay.week
            ? null
            : "مقدار پرداخت سه ماهه نمیتواند خالی یا از مبالغ قبلی کمتر باشد";
        }
        case "sixMonth": {
          return v > 0 &&
            v > this.advertising.pay.day &&
            v > this.advertising.pay.month &&
            v > this.advertising.pay.treeMonth &&
            this.advertising.pay.week
            ? null
            : "مقدار پرداخت شش ماهه نمیتواند خالی یا از مبالغ قبلی کمتر باشد";
        }
        case "year": {
          return v > 0 &&
            v > this.advertising.pay.day &&
            v > this.advertising.pay.month &&
            v > this.advertising.pay.treeMonth &&
            v > this.advertising.pay.sixMonth &&
            this.advertising.pay.week
            ? null
            : "مقدار پرداخت سالیانه نمیتواند خالی یا از مقدار قبلی کمتر باشد";
        }
      }
    },
    submitBanner() {
      this.loading = true;

      if (this.advertising.number < 1) {
        this.$toast.error("حداقل تعداد بنر تبلیغاتی نمیتواند از یک کمتر باشد");
        this.loading = false;

        return;
      }

      let confirm = {
        status: true,
        message: "تنظیمات بنر شما با موفقیت ثبت شد",
      };
      const pay = Object.keys(this.advertising.pay);
      pay.forEach((item) => {
        if (this.rulesSetting(item, this.advertising.pay[item]) !== null) {
          confirm = {
            status: false,
            message: this.rulesSetting(item, this.advertising.pay[item]),
          };
        }
      });

      if (confirm.status) {
        const banner = {
          name: String(this.advertising.number),
          type: "physical",
          pay: this.advertising.pay,
          active: this.advertising.active ? 1 : 2,
          information: { name: String(this.advertising.number) },
          id: this.advertising.id,
        };
        this.loading = true;
        this.$api
          .post(`${this.$qrApi}/v1/commercial/banner/${this.value}`, banner)
          .then((data) => {
            this.loading = false;
            this.$toast.success(
              "نرخ رزرو بنر تبلیغاتی شما با موفقیت بروزرسانی شد",
            );
            this.getBanner();
          })
          .catch((err) => {
            this.loading = false;
            this.getBanner();
          });
      } else {
        this.$toast.error(confirm.message);
        this.loading = false;
      }
    },
    getBanner() {
      this.loading = true;
      this.$api
        .get(`${this.$qrApi}/v1/commercial/banner/${this.value}`)
        .then(({ data }) => {
          this.loading = false;
          if (exception.length > 0) {
            this.advertising = {
              active: true,
              number: 1,
              pay: {
                day: 1000,
                week: 2000,
                month: 3000,
                treeMonth: 4000,
                sixMonth: 5000,
                year: 6000,
              },
            };
          } else {
            this.advertising = {
              number: Number(data.name),
              pay: data.pay,
              active: data.active === 1 ? true : false,
              id: data.id,
            };
          }
        })
        .catch((error) => {
          this.advertising = {
            active: true,
            number: 1,
            pay: {
              day: 1000,
              week: 2000,
              month: 3000,
              treeMonth: 4000,
              sixMonth: 5000,
              year: 6000,
            },
          };
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
